module.exports = __webpack_public_path__ + "img/illu-dingo.e5d71241.svg";